import { get, writable, derived } from 'svelte/store';
import { translations, defaultLocale } from './translations';
import { detectLanguage } from './language-utils';

function createLanguageStore() {
    const { subscribe, set, update } = writable(detectLanguage());

    // Listen for URL changes (for SPA navigation)
    if (typeof window !== 'undefined') {
        window.addEventListener('popstate', () => {
            set(detectLanguage());
        });
    }

    return {
        subscribe,
        setLanguage: (language) => {
            if (translations[language]) {
                set(language);
                // Update URL without reloading the page
                const url = new URL(window.location);
                url.searchParams.set('lang', language);
                window.history.pushState({}, '', url);
            }
        },
        reset: () => {
            set(defaultLocale);
            // Remove lang parameter from URL
            const url = new URL(window.location);
            url.searchParams.delete('lang');
            window.history.pushState({}, '', url);
        }
    };
}

export const language = createLanguageStore();

export const t = derived(
    language,
    $language => (key) => {
        const keys = key.split('.');
        let value = translations[$language];
        
        for (const k of keys) {
            if (value === undefined) return key;
            value = value[k];
        }
        
        return value || key;
    }
);

/**
 *
 * @param key - 'text.text'
 * @param data - {max: 5}
 * @returns {*}
 */
export const instantTranslate = (key, data) => {

    let value = get(t)(key) || key;

    const replaces = Object.keys(data);
    (replaces || []).forEach(r => {
        value = value.replace(`{${r}}`, data[r])
    });

    return value;
}
